function ChangePasswordNavIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" id="createPassword">
      <path
        stroke="#8E33FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M17.5 10.834V7a2 2 0 00-2-2h-11a2 2 0 00-2 2v4.334a2 2 0 002 2H10M12.083 15.416l1.667 1.667 3.333-3.333M10 9.175l.008-.01M13.333 9.175l.009-.01M6.667 9.175l.008-.01"
      ></path>
    </svg>
  );
}

export default ChangePasswordNavIcon;
